import styled from "styled-components"

export const ThumbnailsStyledLi = styled.li` 
    opacity: ${({ hidden }) => hidden && '1'};
    
    &:not(:last-child) {
        margin-bottom: 2rem;
    }
`;